// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".service-case-referred-to-form__field-container{margin-bottom:40px}", ""]);
// Exports
module.exports = exports;
